/**
 * IIFE bundle entry — exposes the Otokoç Widget Kit on the global scope.
 *
 * Built with `vite build --config vite.config.bundle.ts` and served at
 * `/bundle/otokoc-kit.js`. The bundle is self-contained with the embedded
 * chat frontend under `frontend/chatfe`.
 * The production injector (`gengage-assistant-injector/otokoccomtr`) loads
 * this single script and calls `window.OtokocKit.mount(config)`.
 */

import { mountOtokocKit, type OtokocKitConfig, type OtokocKitController } from './index.js';

export type { OtokocKitConfig, OtokocKitController };

declare global {
  interface Window {
    OtokocKit?: {
      mount(config: OtokocKitConfig): Promise<OtokocKitController>;
    };
  }
}

window.OtokocKit = { mount: mountOtokocKit };
